import { postRequest } from 'utils/api'
import { USERS_URL } from 'services/constants'
import { useState } from 'react'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import SmallButton from 'components/atoms/button/SmallButton'
import { useTranslation } from 'react-i18next'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import NotificationSnackBar from 'components/molecules/notificationOverlay/NotificationSnackBar'
import RowStack from 'components/atoms/container/RowStack'
import { Button } from '@mui/material'
import OverlayLoading from 'components/atoms/OverlayLoading'
import { getFullName } from 'utils/formatText'

const ReactivateUserButton = ({ successCallback, user, licenseAvailable }) => {
  const { t } = useTranslation()
  const [sendDialogOpen, setDialogOpen] = useState(false)
  const [requestError, setRequestError] = useState(null)
  const [snackBarOpen, setSnackBarOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleDialogSelect = async licensed => {
    setLoading(true)
    const res = await postRequest(`${USERS_URL}/${user.id}/reactivate`, {
      licensed
    })
    if (res.status === 200) {
      await successCallback(user.id)
      setRequestError(false)
      setSnackBarOpen(true)
      setDialogOpen(false)
    } else {
      setRequestError(true)
    }
    setLoading(false)
  }
  return (
    <>
      <SmallButton
        onClick={() => setDialogOpen(true)}
        data-testid={`reactivate-user-${user.id}`}>
        {t('company.reactivate')}
      </SmallButton>
      <CommonDialog
        open={sendDialogOpen}
        titleText={t('company.reactivateUser')}
        onClose={() => setDialogOpen(false)}
        notificationText={t('company.reactivateWithLicenseQuestion', {userName: getFullName(user, true)})}
        showCloseButton={true}>
        {requestError ? <RequestRetryAlert /> : null}
        <RowStack>
          <Button
            size='small'
            color='primary'
            disabled={!licenseAvailable}
            onClick={() => handleDialogSelect(true)}>
            {t('company.yesWithLicense')}
          </Button>
          <Button size='small' onClick={() => handleDialogSelect(false)}>
            {t('company.reactivateWithoutLicense')}
          </Button>
        </RowStack>
      </CommonDialog>
      <NotificationSnackBar
        open={snackBarOpen}
        setOpen={setSnackBarOpen}
        success={requestError === false}
      />
      <OverlayLoading open={loading} />
    </>
  )
}

export default ReactivateUserButton
